module.exports = __webpack_public_path__ + "img/boy-math.ba6b4e6c.gif";